import React from 'react';
import { sortByName } from '../../../../../utils/sortingUtils';
import LinkedItemsCard from './LinkedItemsCard';

/**
 * LinkedFeatures component
 * Displays a list of features linked to the current family
 */
export default function LinkedFeatures({ features, onSelectFeature }) {
    const sortedFeatures = sortByName(features || [], 'name');

    return (
        <LinkedItemsCard icon="fa-solid fa-tag" title="Features" count={sortedFeatures.length}>
            {sortedFeatures.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {sortedFeatures.map(feat => (
                        <button
                            key={feat.id}
                            type="button"
                            className="linked-item-row clickable-row"
                            onClick={() => onSelectFeature?.(feat)}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0.5rem 0.75rem',
                                border: '1px solid var(--border)',
                                fontSize: '0.85rem',
                                width: '100%',
                                fontFamily: 'inherit',
                                textAlign: 'left',
                                gap: '0.75rem'
                            }}
                        >
                            <span className="row-title" style={{ fontFamily: 'monospace' }}>{feat.name}</span>
                            <span className="row-muted" style={{ fontSize: '0.75rem' }}>
                                {[
                                    (feat.property?.isSystem || feat.isSystem) ? 'System' : null,
                                    (feat.property?.isOutput || feat.isOutput) ? 'Output' : null
                                ].filter(Boolean).join(' · ') || 'Input'}
                            </span>
                        </button>
                    ))}
                </div>
            ) : (
                <p style={{
                    fontStyle: 'italic',
                    color: 'var(--text-secondary)',
                    fontSize: '0.85rem',
                    margin: 0
                }}>
                    No features currently mapped.
                </p>
            )}
        </LinkedItemsCard>
    );
}
